import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import { FollowUpModel } from '../model/index';

@Injectable()
export class FollowUpService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    // private headers = new Headers( {
    //     'Content-Type': 'application/json',
    //     'Accept': 'application/json'
    // });
    private followUpUrl = 'api/followUp';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getFollowUpList(query: any): Promise<FollowUpModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.followUpUrl}/followUpList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getFutureCalendarCounts(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.followUpUrl}/futureCalendarCounts`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getEntriesByDate(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.followUpUrl}/entriesByDate`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getFollowUpDetails(pageData: any): Promise<FollowUpModel> {
        const url = `${this.followUpUrl}/getFollowUpDetails`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as FollowUpModel)
            .catch(this.handleError);
    }

    changeAttenderStatus(pageData: any): Promise<FollowUpModel> {
        const url = `${this.followUpUrl}/changeAttenderStatus`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as FollowUpModel)
            .catch(this.handleError);
    }


    saveFollowUpDet(pageData: any): Promise<any> {
        const url = `${this.followUpUrl}/saveFollowUpDet`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getSatisficationApprovalList(query: any): Promise<FollowUpModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.followUpUrl}/getSatisficationApprovalList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    saveCustomerSatisficationApproval(query: any): Promise<FollowUpModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.followUpUrl}/saveCustomerSatisficationApproval`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    private handleError(error: any): Promise<FollowUpModel> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/followUp.service.ts